import React, { Component } from "react";
import { connect } from "react-redux";
import ShapedBox from "../../common/ShapedBox";
import { path } from "ramda";
import './style.css';
import Preloader from "../../common/Preloader";
import Breadcrumbs from "../../common/Breadcrumbs";
import { fetchCustomers } from "../../api/checkIn";
import { fetchWorker } from "../../api/employees";

class SelectCustomer extends Component {
    componentDidMount() {
        const { userid } = this.props.match.params;
        this.props.getCustomers();
        this.props.loadWorker(userid);
        window.scrollTo(0, 0);
    }


    render() {
        const { userid } = this.props.match.params;
        
        const customers = path(['checkIn', 'customers'], this.props);
        const worker = path(['employees', 'worker'], this.props);
        const workerFullname = worker ? `${worker.firstname} ${worker.lastname}` : '';

        return (
            <div>
                <Breadcrumbs
                    list={[
                        { url: '/pages/check-in', icon: 'perm_contact_calendar', name: 'Check In' },
                        { url: '/pages/check-in', icon: 'person', name: `${workerFullname}` },
                        { url: '/pages/check-in', icon: 'assignment', name: 'New Work' },
                    ]}
                />
                <div className="card">
                    <div className="card-header rounded-top">Choose Customer</div>
                    <div className="card-block">
                        <div className="d-flex justify-content-end align-items-center">
                            <div><button className="btn btn-rounded btn-icon ui-btn pull-right"
                                onClick={() => this.props.history.goBack()}>Cancel</button></div>
                        </div>
                        {!!customers ?
                            <div className="list-container">
                                {customers.map((customer, index) => {
                                    return (
                                        <ShapedBox onClick={() => this.props.history.push(`/pages/check-in/${customer.id}/work-order`, { 'customer': customer.name, userid })}>
                                            <div className="h-100 p-3 pointer">
                                                <div className="text-default fixed-lines">{customer.name}</div>
                                                <br />
                                                <div className="text-default text-truncate">
                                                    <span className="h5">{customer.task_count}</span> Work Order{`${customer.task_count > 1 ? `s` : ``}`}
                                                </div>
                                            </div>
                                        </ShapedBox>
                                    )
                                })}
                            </div>
                            :
                            <Preloader
                                show={true}
                                type={'circle'}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: () => {
            fetchCustomers()(dispatch);
        },
        loadWorker: (workerId) => {
            fetchWorker(workerId)(dispatch);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCustomer);


// WEBPACK FOOTER //
// ./src/containers/SelectCustomer/index.js